import { render, staticRenderFns } from "./AdicionarNota.vue?vue&type=template&id=41ab4c9d"
import script from "./AdicionarNota.vue?vue&type=script&lang=js"
export * from "./AdicionarNota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports